<template>
  <div>
    <b-modal
      id="upload-form-modal"
      centered
      title="Upload Salary Adjustment Type"
      header-bg-variant="dark"
      :hide-footer="true"
    >
      <b-row>
        <b-col>
          <b-form-group>
            <label for="name">Select File</label>
            <b-form-file
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="handleFileChange($event)"
              ref="file_input"
            ></b-form-file>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            type="button"
            variant="warning"
            class="mr-1 btn-sm text-white"
						@click="save"
          >Save</b-button>
          <b-button
            type="button"
            variant="danger"
            class="mr-1 btn-sm text-white"
						@click="cancel"
          >Cancel</b-button>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapActions, mapGetters } from 'vuex'
export default {
	name: "UploadHoliday",
	data(){
		return {
			file: null,
			items: null,
		}
	},
  methods: {
		...mapActions(['savePayrollSalaryAdjustmentType', 'getPayrollSalaryAdjustmentTypes']),
		handleFileChange: function(event) {
      this.file = event.target.files[0];
    },
    show() {
      this.$bvModal.show("upload-form-modal");
		},
		cancel() {
      this.$bvModal.hide("upload-form-modal");
		},
		save(){
			let file = this.file;

			let reader = new FileReader();
				
		   reader.onload = (function(e) {
		      let data = new Uint8Array(reader.result);
		      let workbook = XLSX.read(data, { type: "array" });
		      let worksheetName = workbook.SheetNames[0];
		      let worksheet = workbook.Sheets[worksheetName];

					let excel_data = XLSX.utils.sheet_to_json(worksheet, {
						raw: false,
						header: [
							"SalaryAdjustmentTypeID",
		          "SalaryAdjustmentTypeName",
		          "Entry",
		          "ForClientAdjustment",
		          "IsActive",
		          "IsDeleted"
						]
					}); 

					excel_data.splice(0, 2);

					const adjustmenttypeList = formatAdjustmentTypeData(excel_data);
					
					store(adjustmenttypeList);
			});

			reader.readAsArrayBuffer(file);

			const formatAdjustmentTypeData = rawData => {
	      let newFormat = {};
	      let newFormatList = [];

	      for (var i = 0; i < rawData.length; i++) {
	        newFormat = {};
	        newFormat.SalaryAdjustmentTypeID = rawData[i].SalaryAdjustmentTypeID;
	        newFormat.SalaryAdjustmentTypeName =
	          rawData[i].SalaryAdjustmentTypeName;
	        newFormat.Entry = rawData[i].Entry;
	        newFormat.ForClientAdjustment = rawData[i].ForClientAdjustment;
	        newFormat.IsActive = rawData[i].IsActive;
	        newFormat.IsDeleted = rawData[i].IsDeleted;

	        newFormatList.push(newFormat);
	      }

	      return newFormatList;
	    };
			
				const store = (data) => {
					this.savePayrollSalaryAdjustmentType(data).then(res=>{
					this.getPayrollSalaryAdjustmentTypes();
						this.$swal({
							title: "Success",
							text: "Successful Import",
							icon: "success"
						});
						this.isLoading = false;
						this.cancel();
					})
					.catch(errors => {
						this.$swal({
							title: "Error",
							text: errors.response.message,
							icon: "error"
						});
					});
				}	

		},

	
	},
	
};
</script>
